import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="container nav-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img 
              src="/logo-placeholder.png" 
              alt="Blackswift Inventories" 
              className="logo-image"
            />            
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`menu-btn ${isOpen ? 'open' : ''}`} 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation Links */}
        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setIsOpen(false)}>HOME</Link>
          <Link to="/about" onClick={() => setIsOpen(false)}>ABOUT</Link>
          <Link to="/services" onClick={() => setIsOpen(false)}>SERVICES</Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>CONTACT</Link>
          <Link 
            to="/contact" 
            className="btn nav-cta" 
            onClick={() => setIsOpen(false)}
            style={{ color: '#ffffff' }}   // 👈 Makes text white
          >
            Get In Touch
          </Link>
          {/* Social Icons */}
          <div className="nav-social">
            <a href="https://x.com/blackswift" target="_blank" rel="noopener noreferrer" aria-label="X">
              <i className="fab fa-x-twitter"></i>
            </a>
            <a href="https://facebook.com/blackswift" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://instagram.com/blackswift" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;